var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
function parseOrigin(url) {
  const u = new URL(url);
  return u.origin;
}
function parseNamespace(url) {
  const u = new URL(url);
  return u.hostname.split(/\./g).reverse().join(".");
}
function safeGetSrc(el) {
  let result;
  try {
    result = el.src;
  } catch (e) {
  }
  return result;
}
function safeGetWindow(el) {
  let result;
  try {
    result = el.contentWindow || el;
  } catch (e) {
    result = el;
  }
  return result;
}
function uuid() {
  return typeof crypto !== "undefined" && (crypto == null ? void 0 : crypto.randomUUID) && crypto.randomUUID() || Math.random().toString(36).split(".").filter(Boolean).join("");
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var isobject = function isObject(val) {
  return val != null && typeof val === "object" && Array.isArray(val) === false;
};
/*!
 * get-value <https://github.com/jonschlinkert/get-value>
 *
 * Copyright (c) 2014-2018, Jon Schlinkert.
 * Released under the MIT License.
 */
const isObject2 = isobject;
var getValue = function(target, path, options) {
  if (!isObject2(options)) {
    options = { default: options };
  }
  if (!isValidObject(target)) {
    return typeof options.default !== "undefined" ? options.default : target;
  }
  if (typeof path === "number") {
    path = String(path);
  }
  const isArray = Array.isArray(path);
  const isString = typeof path === "string";
  const splitChar = options.separator || ".";
  const joinChar = options.joinChar || (typeof splitChar === "string" ? splitChar : ".");
  if (!isString && !isArray) {
    return target;
  }
  if (isString && path in target) {
    return isValid(path, target, options) ? target[path] : options.default;
  }
  let segs = isArray ? path : split(path, splitChar, options);
  let len = segs.length;
  let idx = 0;
  do {
    let prop = segs[idx];
    if (typeof prop === "number") {
      prop = String(prop);
    }
    while (prop && prop.slice(-1) === "\\") {
      prop = join([prop.slice(0, -1), segs[++idx] || ""], joinChar, options);
    }
    if (prop in target) {
      if (!isValid(prop, target, options)) {
        return options.default;
      }
      target = target[prop];
    } else {
      let hasProp = false;
      let n = idx + 1;
      while (n < len) {
        prop = join([prop, segs[n++]], joinChar, options);
        if (hasProp = prop in target) {
          if (!isValid(prop, target, options)) {
            return options.default;
          }
          target = target[prop];
          idx = n - 1;
          break;
        }
      }
      if (!hasProp) {
        return options.default;
      }
    }
  } while (++idx < len && isValidObject(target));
  if (idx === len) {
    return target;
  }
  return options.default;
};
function join(segs, joinChar, options) {
  if (typeof options.join === "function") {
    return options.join(segs);
  }
  return segs[0] + joinChar + segs[1];
}
function split(path, splitChar, options) {
  if (typeof options.split === "function") {
    return options.split(path);
  }
  return path.split(splitChar);
}
function isValid(key, target, options) {
  if (typeof options.isValid === "function") {
    return options.isValid(key, target);
  }
  return true;
}
function isValidObject(val) {
  return isObject2(val) || Array.isArray(val) || typeof val === "function";
}
const getValue$1 = /* @__PURE__ */ getDefaultExportFromCjs(getValue);
function rematerialize(schema, fn) {
  const api = {};
  const stack = [{ api, schema, path: "" }];
  while (stack.length) {
    const current = stack.shift();
    for (const [key, value] of Object.entries(current.schema)) {
      const path = [current.path, key].filter(Boolean).join(".");
      if (value.type === "function") {
        current.api[key] = async (...args) => {
          return fn({
            path,
            args
          });
        };
      } else if (value.type === "ref") {
        current.api[key] = value.path === "" ? api : getValue$1(api, value.path);
      } else {
        stack.push({
          api: current.api[key] = {},
          schema: value,
          path
        });
      }
    }
  }
  return api;
}
function entries(obj) {
  if (obj == null) {
    return [];
  }
  if (Object.getPrototypeOf(obj) === Object.getPrototypeOf({})) {
    return Object.entries(obj);
  }
  let keys = Object.getOwnPropertyNames(Object.getPrototypeOf(obj));
  keys.push(...Object.getOwnPropertyNames(obj));
  keys = keys.filter((k) => k !== "constructor");
  const entries2 = keys.map((key) => [key, obj[key]]);
  return entries2;
}
function dematerialize(api) {
  const visited = /* @__PURE__ */ new WeakMap();
  const schema = {};
  const stack = [{ api, schema, path: "" }];
  if (api == null) {
    return schema;
  }
  visited.set(api, "");
  while (stack.length) {
    const current = stack.shift();
    for (const [key, value] of entries(current.api)) {
      const path = current.path + (current.path ? "." : "") + key;
      const valueType = typeof value;
      if (visited.has(value)) {
        current.schema[key] = {
          type: "ref",
          path: visited.get(value)
        };
        continue;
      } else if (value && valueType === "object") {
        visited.set(value, path);
      }
      if (valueType === "function") {
        current.schema[key] = {
          type: "function",
          // number of args
          length: value.length
        };
      } else if (value && valueType === "object") {
        stack.push({
          api: value,
          schema: current.schema[key] = {},
          path
        });
      }
    }
  }
  return schema;
}
function executor(api, schema) {
  const pathCache = /* @__PURE__ */ new Map();
  return (req) => {
    const args = req.args;
    const path = req.path;
    let resolved = pathCache.get(path);
    if (!resolved) {
      resolved = resolvePath(path);
      pathCache.set(path, resolved);
    }
    return resolved.fn.apply(resolved.parent, args);
  };
  function resolvePath(path) {
    const stack = path.split(/\./g);
    let currentSchema = schema;
    let curentApi = api;
    let parent;
    while (stack.length) {
      const node = stack.shift();
      parent = curentApi;
      currentSchema = currentSchema[node];
      curentApi = curentApi[node];
      if (!currentSchema) {
        throw new Error("method not defined in schema");
      }
      if (!curentApi) {
        throw new Error("method not found");
      }
    }
    return { fn: curentApi, parent };
  }
}
function generateSchemaFromApi(api) {
  return dematerialize(api);
}
function exposeApi(api) {
  const schema = generateSchemaFromApi(api);
  const exec = executor(api, schema);
  return async (request) => {
    if (request.introspect) {
      return schema;
    }
    if (request.method) {
      return exec({
        path: request.method,
        args: request.args
      });
    }
  };
}
function generateApiFromSchema(schema, method, ip) {
  return rematerialize(schema, ({ path, args }) => {
    return ip.call(method, {
      method: path,
      args
    });
  });
}
function toError(message) {
  const error = new Error(message.error.message);
  error.stack = message.error.stack;
  error.code = message.error.code;
  return error;
}
const _BorderProtocol = class _BorderProtocol {
  /**
   * Creates an instance of BorderProtocol.
   *
   * @static
   * @param {BorderProtocolOptions} [opts]
   * @return {BorderProtocol} 
   * @memberof BorderProtocol
   */
  static init(opts) {
    return new _BorderProtocol(opts);
  }
  /**
   * Creates an instance of BorderProtocol.
   * 
   * @param {BorderProtocolOptions} [opts]
   * @memberof BorderProtocol
   */
  constructor(opts) {
    opts = opts || {};
    this.name = opts.name || uuid();
    this.logger = opts.logger || false;
    this.helloInterval = opts.helloInterval || 0;
    this.helloTimeout = opts.helloTimeout || 0;
    this.helloCheck = opts.helloCheck || 0;
    this.targets = [];
    this.messageHandlers = /* @__PURE__ */ new Map();
    this.instance = uuid();
    this.requireReady = opts.requireReady ?? false;
    this.callMessageOptions = opts.callMessageOptions || { requireHandler: true };
    setTimeout(() => this.registerProtocolEvents(), 0);
    setTimeout(() => this.initialize(), 0);
  }
  /**
   * Register default protocol events
   *
   * @memberof BorderProtocol
   */
  registerProtocolEvents() {
    if (this.helloTimeout && this.helloCheck) {
      this.receive({ from: { name: _BorderProtocol.NAME_HELLO } }, (message) => {
        message.from.target.lastHello = Date.now();
      });
      this._intervalHelloCheck = setInterval(() => {
        const targets = this.getTargets();
        const now = Date.now();
        for (const target of targets) {
          if (target.lastHello && now - target.lastHello > this.helloTimeout) {
            this.removeTarget(target);
          }
        }
      }, this.helloCheck);
    }
    if (this.helloInterval) {
      this._intervalHello = setInterval(() => {
        this.send({ to: { name: _BorderProtocol.NAME_HELLO } });
      }, this.helloInterval);
    }
  }
  /**
   * Default initialization function. Does nothing
   *
   * @memberof BorderProtocol
   */
  initialize() {
  }
  /**
   * Dispatch messages to internally registered handlers
   * 
   * - The `to` property of the message is used to generate a handler key.
   *   - the handler key is described in the {@link getHandlerKey} method.
   * - The handler key is used to lookup registered handlers.
   * - If the incoming message options require a handler and there are no 
   *   handlers registered, then an error is sent back to the sender.
   * - If the incoming message options do not require a handler and there 
   *   are no registered handlers, then the message is ignored.
   * - Otherwise, all registered handlers are called with the message and
   *   event.
   *
   * @param {Partial<BorderProtocolMessage>} message
   * @param {MessageEvent} [event]
   * @memberof BorderProtocol
   */
  dispatch(message, event) {
    var _a;
    const handlerKey = this.getHandlerKey(message.to);
    this.log("dispatch: handlerKey=%s, id=%s", handlerKey, message.id, message);
    const handlers = this.messageHandlers.get(handlerKey);
    if (!handlers) {
      if ((_a = message.options) == null ? void 0 : _a.requireHandler) {
        this.log("dispatch: no handlers for %s", handlerKey);
        this.send({
          to: { target: message.from.target, name: message.id },
          error: { message: `no handlers for ${handlerKey}` }
        });
      }
      return;
    }
    for (const handler of handlers.values()) {
      handler(message, event);
    }
  }
  /**
   * Send a message out to registered targets
   *
   * The `to` property of the message is used to determine which targets
   * to send the message to. The details of how this is done are described
   * in the {@link getTargets} method.
   * 
   * @param {object} opts
   * @param {BorderProtocolMessageDesignation} [opts.to]
   * @param {any} [opts.data]
   * @param {BorderProtocolMessageOptions} [opts.options]
   * @param {BorderProtocolMessageError} [opts.error]
   * @return {BorderProtocolMessage} 
   * @memberof BorderProtocol
   */
  send(opts) {
    var _a;
    if (this.targets.length === 0) {
      this.log("send: warning: there are no registered targets yet");
    }
    const to = opts.to;
    const data = opts.data;
    const options = opts.options;
    const error = opts.error;
    const message = {
      ip: _BorderProtocol.MAGIC_NUMBER,
      id: uuid(),
      to,
      data,
      options,
      error
    };
    let targets = this.getTargets(opts.to);
    if (targets.length === 0) {
      this.log("send: no matching targets for message", message);
    }
    (_a = message.to) == null ? true : delete _a.target;
    for (const target of targets) {
      target.send(message);
    }
    return message;
  }
  /**
   * Register event handlers for designated events.
   * 
   * These are events we expect to receive from an external source. 
   * We use the `from` property of the message to generate a handler 
   * key. The details of how this is done are described in the
   * {@link getHandlerKey} method.
   * 
   * When we receive a message, we generate the same handler key
   * based on the `to` property of the message and then call all
   * registered handlers for that key. That step is handled in the
   * {@link dispatch} method.
   *
   * @param {object} opts
   * @param {BorderProtocolMessageDesignation} opts.from
   * @param {(message:BorderProtocolMessage, event:MessageEvent) => any} fn
   * @return {() => void} off()
   * @memberof BorderProtocol
   */
  receive(opts, fn) {
    const handlerKey = this.getHandlerKey(opts.from);
    this.log("receive: registering %s", handlerKey);
    let handlers = this.messageHandlers.get(handlerKey);
    if (!handlers) {
      handlers = /* @__PURE__ */ new Set();
      this.messageHandlers.set(handlerKey, handlers);
    }
    handlers.add(fn);
    return () => {
      this.log("receive: unregistering %s", handlerKey);
      handlers.delete(fn);
      if (handlers.size === 0) {
        this.messageHandlers.delete(handlerKey);
      }
    };
  }
  /**
   * Add a target to the target list
   *
   * @param {IBorderProtocolTarget} target
   * @memberof BorderProtocol
   */
  addTarget(target) {
    if (!target) {
      throw new Error("BorderProtocol:addTarget: target must be specified");
    }
    this.targets.push(target);
    this.dispatch({
      to: {
        name: "target"
      },
      data: [target]
    });
  }
  /**
   * Remove a target from the target list
   *
   * @param {IBorderProtocolTarget} target
   * @memberof BorderProtocol
   */
  removeTarget(target) {
    this.targets.splice(this.targets.indexOf(target), 1);
    this.dispatch({
      to: {
        name: "target:removed"
      },
      data: [target]
    });
  }
  /**
   * Get targets based on {@link BorderProtocolMessageDesignation to}
   * 
   * - If `to` is falsey, then all registered targets are returned
   * - if `to.target` is set, then only that target is returned
   * - if `to.targets` is set, then only those targets are returned
   * - otherwise, we filter targets based on the following criteria:
   *   - if `to.instance` is set, and the target does not have that instance id, then it is excluded
   *   - if `to.namespace` is set, and the target does not have that namespace, then it is excluded
   *   - if `to.target` is set, and the target does not match that target, then it is excluded
   *     - NOTE: this may be reduntant with the `to.target` check above
   *
   * @param {BorderProtocolMessageDesignation} [to]
   * @return {IBorderProtocolTarget[]} 
   * @memberof BorderProtocol
   */
  getTargets(to) {
    if (!to) {
      return this.targets;
    }
    if (to.target) {
      return [to.target];
    }
    if (to.targets) {
      return to.targets;
    }
    return this.targets.filter((target) => {
      if (this.requireReady && !target.ready) {
        return false;
      }
      if (to.instance && to.instance !== target.instance) {
        return false;
      }
      if (to.namespace && to.namespace !== target.namespace) {
        return false;
      }
      if (to.target && to.target !== target) {
        return false;
      }
      return true;
    });
  }
  /**
   * Generate a handler key for message callback registration
   * 
   * @param {BorderProtocolMessageDesignation} to
   * @return {string}
   */
  getHandlerKey(to) {
    to = to || {};
    return [to.namespace, to.instance, to.name].filter(Boolean).join(":");
  }
  /**
   * Log internal debug messages
   *
   * @param {*} args
   * @memberof BorderProtocol
   */
  log(...args) {
    if (!this.logger) {
      return;
    }
    const message = args.shift();
    this.logger(`BorderProtocol: [${this.name}]: ${message}`, ...args);
  }
  /**
   * Emit an event out to registered external targets
   *
   * @param {string} name
   * @param {any} args
   * @return {BorderProtocolMessage} 
   * @memberof BorderProtocol
   */
  emit(name, ...args) {
    this.log("emit: %s", name, args);
    return this.send({
      to: { name },
      data: args
    });
  }
  /**
   * Register event handlers for named events
   * 
   * @template D
   * @param {string} name
   * @param {(D) => void} fn
   * @return {() => void} off()
   * @memberof BorderProtocol
   */
  on(name, fn) {
    this.log("on: registering %s", name);
    return this.receive({ from: { name } }, (message, event) => {
      fn(...message.data);
    });
  }
  /**
   * Register event handlers for named events. The handler
   * will only be called one time and then removed from the
   * list of handlers for the event.
   * 
   * @template D
   * @param {string} name
   * @param {(D) => void} fn
   * @return {() => void} off()
   * @memberof BorderProtocol
   */
  once(name, fn) {
    this.log("once: registering %s", name);
    const off = this.on(name, (...args) => {
      off();
      fn(...args);
    });
    return off;
  }
  /**
   * If name and fn are provided, fn is removed from the handlers for the named event
   * If only name is provided, all handlers for the named event are removed
   * If only fn is provided, fn is removed from all events
   *
   * @param {string} [name]
   * @param {() => void} [fn]
   * @memberof BorderProtocol
   */
  off(name, fn) {
    if (name && fn) {
      const handlers = this.messageHandlers.get(name);
      handlers.delete(fn);
      if (handlers.size === 0) {
        this.messageHandlers.delete(name);
      }
    } else if (typeof name === "string") {
      const handlers = this.messageHandlers.get(name);
      handlers == null ? void 0 : handlers.clear();
      this.messageHandlers.delete(name);
    } else if (typeof name === "function") {
      fn = name;
      for (const [handlerKey, handlers] of this.messageHandlers.entries()) {
        handlers.delete(fn);
        if (handlers.size === 0) {
          this.messageHandlers.delete(handlerKey);
        }
      }
    }
  }
  /**
   * Wait for an event to occur one time and receive its results
   * 
   * @template D
   * @param {string} name
   * @param {Promise} [cancelled]
   * @return {Promise<D>} 
   * @memberof BorderProtocol
   */
  wait(name, cancelled) {
    return new Promise((resolve, reject) => {
      if (cancelled) {
        cancelled.then(resolve).catch(reject);
      }
      this.once(name, (...args) => {
        resolve(args);
      });
    });
  }
  /**
   * Return an async iterator that iterates over received events
   * 
   * @template D
   * @param {string} name name of event to receive events for
   * @param {Promise} [cancelled] optional promise that when resolved cancels waiting for events
   * @return {AsyncGenerator<D>}
   * @memberof BorderProtocol
   */
  async *waiterator(name, cancelled) {
    let proceed = true;
    if (cancelled) {
      cancelled.then(() => proceed = false).catch(() => proceed = false);
    }
    while (proceed) {
      const result = await this.wait(name, cancelled);
      if (proceed) {
        yield result;
      }
    }
  }
  /**
   * Register a function/method or API/object for remote consumption
   *
   * @param {string} method
   * @param {function|object} entity
   * @return {() => void} off()
   * @memberof BorderProtocol
   */
  register(method, entity) {
    this.log("register: %s", method);
    const type = typeof entity;
    if (type === "function") {
      return this.registerFunction(method, entity);
    } else if (type === "object") {
      return this.registerApi(method, entity);
    } else {
      throw new Error("BorderProtocol:register unknown entity type for registration: " + type);
    }
  }
  /**
   * Register a function/method for remote consumption
   * 
   * @template A, R
   * @param {string} method
   * @param {(A) => R} fn
   * @return {() => void} off()
   * @memberof BorderProtocol
   */
  registerFunction(method, fn) {
    return this.receive({ from: { name: method } }, async (message, event) => {
      let result = await fn(...message.data);
      this.send({
        to: {
          target: message.from.target,
          name: message.id
        },
        data: {
          id: message.id,
          result
        }
      });
    });
  }
  /**
   * Register an API for remote consumption
   * 
   * @template A
   * @param {string} method
   * @param {A} api
   * @return {() => void} off()
   * @memberof BorderProtocol
   */
  registerApi(method, api) {
    return this.registerFunction(method, exposeApi(api));
  }
  /**
   * Get an API that was registered elsewhere
   * 
   * @template A
   * @param {string} method
   * @return {Promise<A>} 
   * @memberof BorderProtocol
   */
  async getApi(method) {
    let schema = await this.call(method, { introspect: true });
    return generateApiFromSchema(schema, method, this);
  }
  /**
   * Call a method that was registered on some remote
   * 
   * @template R
   * @param {string} name method name
   * @param {any[]} args
   * @return {Promise<R>} 
   * @memberof BorderProtocol
   */
  call(name, ...args) {
    this.log("call: %s", name, args);
    return new Promise((resolve, reject) => {
      const options = this.callMessageOptions;
      const message = this.send({ to: { name }, data: args, options });
      const off = this.receive({ from: { name: message.id } }, (message2, raw) => {
        off();
        if (message2.error) {
          return reject(toError(message2));
        }
        resolve(message2.data.result);
      });
    });
  }
  /**
   * Terminate all internal timers and clean up other things
   *
   * @memberof BorderProtocol
   */
  shutdown() {
    clearInterval(this._intervalHello);
    clearInterval(this._intervalHelloCheck);
  }
};
/**
 *
 * @type {string}
 * @static
 * @memberof BorderProtocol
 */
__publicField(_BorderProtocol, "MAGIC_NUMBER", "3vqmnir58nv");
/**
 *
 * @type {string}
 * @static
 * @memberof BorderProtocol
 */
__publicField(_BorderProtocol, "NAME_HELLO", "bp.internal.hello");
let BorderProtocol = _BorderProtocol;
const _BorderProtocolTarget = class _BorderProtocolTarget {
  /**
   * Creates an instance of BorderProtocolTarget.
   * @param {object} options
   * @param {BorderProtocol} options.bp parent instance of the border-protocol
   * @param {string} [options.instance] the identifier of the target instance
   * @memberof BorderProtocolTarget
   */
  constructor(options) {
    if (!options) {
      throw new Error("BorderProtocolTarget: options is required");
    }
    if (!options.bp) {
      throw new Error("BorderProtocolTarget: options.bp is required");
    }
    this.bp = options.bp;
    this.instance = options.instance || uuid();
  }
  /**
   * @param {BorderProtocolMessage} message
   * @memberof BorderProtocolTarget
   */
  send(message) {
    throw new Error("Method not implemented.");
  }
  /**
   * Emit an event out to this specific target
   *
   * @param {string} name
   * @param {any} args
   * @return {BorderProtocolMessage} 
   * @memberof BorderProtocolTarget
   */
  emit(name, ...args) {
    return this.bp.send({
      to: {
        name,
        target: this
      },
      data: args
    });
  }
  /**
   * Register an event handler for this specific target
   *
   * @param {string} name
   * @param {(...any)=>void} fn
   * @return {()=>void} 
   * @memberof BorderProtocolTarget
   */
  on(name, fn) {
    return this.bp.receive({
      from: {
        name,
        target: this,
        instance: this.instance
      }
    }, (message) => {
      fn(...message.data);
    });
  }
  /**
   * Register an event handler for this specific target that
   * is called only once
   *
   * @param {string} name
   * @param {(...any)=>void} fn
   * @return {()=>void} off
   * @memberof BorderProtocolTarget
   */
  once(name, fn) {
    const off = this.on(name, (...args) => {
      off();
      fn(...args);
    });
    return off;
  }
  /**
   * Wait for an event to occur one time and receive its results
   * 
   * @template D
   * @param {string} name
   * @param {Promise} [cancelled]
   * @return {Promise<D>} 
   * @memberof BorderProtocol
   */
  wait(name, cancelled) {
    return new Promise((resolve, reject) => {
      if (cancelled) {
        cancelled.then(resolve).catch(reject);
      }
      this.once(name, (...args) => {
        resolve(args);
      });
    });
  }
  /**
   * Return an async iterator that iterates over received events
   * 
   * @template D
   * @param {string} name name of event to receive events for
   * @param {Promise} [cancelled] optional promise that when resolved cancels waiting for events
   * @return {AsyncGenerator<D>}
   * @memberof BorderProtocol
   */
  async *waiterator(name, cancelled) {
    let proceed = true;
    if (cancelled) {
      cancelled.then(() => proceed = false).catch(() => proceed = false);
    }
    while (proceed) {
      const result = await this.wait(name, cancelled);
      if (proceed) {
        yield result;
      }
    }
  }
  /**
   * Call a method that was registered on this target specifically
   * 
   * @template R
   * @param {string} name method name
   * @param {any[]} args
   * @return {Promise<R>} 
   * @memberof BorderProtocolTarget
   */
  call(name, ...args) {
    this.bp.log("target:call: %s", name, args);
    return new Promise((resolve, reject) => {
      const options = this.bp.callMessageOptions;
      const message = this.bp.send({ to: { name, target: this }, data: args, options });
      const off = this.bp.receive({ from: { name: message.id } }, (message2, raw) => {
        off();
        if (message2.error) {
          return reject(message2.error);
        }
        resolve(message2.data.result);
      });
    });
  }
  /**
   * Get an API that was registered elsewhere
   * 
   * @template A
   * @param {string} method
   * @return {Promise<A>} 
   * @memberof BorderProtocolTarget
   */
  async getApi(method) {
    let schema = await this.call(method, { introspect: true });
    return generateApiFromSchema(schema, method, this);
  }
  async handshake() {
    const { SYN, SYN_ACK, ACK, READY } = _BorderProtocolTarget;
    this.once("ready", () => {
      this.ready = true;
    });
    const offSyn = this.once(SYN, () => {
      this.bp.log("handshake: got target syn");
      this.emit(SYN_ACK);
    });
    const offSynAck = this.once(SYN_ACK, () => {
      this.bp.log("handshake: got target syn/ack");
      offSyn();
      offAck();
      this.emit(ACK);
      this.emit(READY);
    });
    const offAck = this.once(ACK, () => {
      this.bp.log("handshake: got target ack");
      offSynAck();
      this.emit(ACK);
      this.emit(READY);
    });
    this.emit(SYN);
  }
  /**
   * If the target is not ready, wait for it to be ready
   *
   * @memberof BorderProtocolTarget
   */
  async isReady() {
    if (!this.ready)
      await this.wait("ready");
  }
};
__publicField(_BorderProtocolTarget, "SYN", "bp.internal.handshake.syn");
__publicField(_BorderProtocolTarget, "SYN_ACK", "bp.internal.handshake.syn-ack");
__publicField(_BorderProtocolTarget, "ACK", "bp.internal.handshake.ack");
__publicField(_BorderProtocolTarget, "READY", "ready");
let BorderProtocolTarget = _BorderProtocolTarget;
class IframeProtocolTarget extends BorderProtocolTarget {
  /**
     * Creates an instance of IframeProtocolTarget.
     * @param {Partial<IframeProtocolTargetOptions>} opts
     * @memberof IframeProtocolTarget
     */
  constructor(opts) {
    super({
      bp: opts.ip,
      instance: opts.instance
    });
    opts = opts || {};
    if (!opts.ip) {
      throw new Error("IframeProtocolTarget: opts.ip is required");
    }
    this.ip = opts.ip;
    this.window = opts.window;
    this.iframe = opts.iframe;
    this.url = opts.url;
    this.target = opts.target;
    this.namespace = opts.namespace;
    this.type = opts.type || this.window === window.parent ? "parent" : "child";
    this.instance = null;
    this.ready = false;
  }
  send(message) {
    try {
      this.window.postMessage(message, this.target);
    } catch (err) {
    }
  }
}
class IframeProtocol extends BorderProtocol {
  /**
     * Creates an instance of IframeProtocol.
     *
     * @static
     * @param {IframeProtocolOptions} [opts]
     * @return {IframeProtocol}
     * @memberof IframeProtocol
     */
  static init(opts) {
    return new IframeProtocol(opts);
  }
  /**
     * Creates an instance of IframeProtocol.
     * @param {IframeProtocolOptions} [opts]
     * @memberof IframeProtocol
     */
  constructor(opts) {
    opts = opts || {};
    super(opts);
    this.attachParent = opts.attachParent ?? true;
    this.allowUnsafeTarget = opts.allowUnsafeTarget ?? false;
    this.target = opts.target;
    this.root = opts.root || document.body;
  }
  /**
     *
     *
     * @memberof IframeProtocol
     */
  initialize() {
    window.addEventListener("message", this.handleIncomingMessage.bind(this));
    if (this.attachParent && window.parent && window.parent !== window) {
      this.attach(window.parent);
    }
  }
  handleIncomingMessage(e) {
    const message = e.data || {};
    if (message.ip !== IframeProtocol.MAGIC_NUMBER) {
      return;
    }
    const from = this.targets.find((t) => t.window === e.source);
    if (!from) {
      this.log('received message with unknown "from", ignoring');
      return;
    }
    if (from.target !== e.origin && from.target !== "*") {
      this.log("received message with incorrect origin, ignoring. expected: %s, actual: %s", from.target, e.origin);
      return;
    }
    message.from = {
      target: from,
      origin: e.origin,
      instance: from.instance
    };
    this.dispatch(message, e);
  }
  /**
     * Load a URL into a new iframe and attach the iframe
     * to this instance
     *
     * @param {string|Partial<IframeProtocolTargetOptions>} opts
     * @return {Promise<IframeProtocolTarget>}
     * @memberof IframeProtocol
     */
  async load(opts) {
    if (typeof opts === "string") {
      opts = {
        url: opts
      };
    }
    const target = await this.createTarget(opts);
    this.addTarget(target);
    await target.handshake();
    return target;
  }
  /**
     *
     *
     * @param {Partial<IframeProtocolTargetOptions>} opts
     * @return {Promise<IframeProtocolTarget>}
     * @memberof IframeProtocol
     */
  async createTarget(opts) {
    opts.iframe = opts.iframe || opts.url && await this.appendIframe(opts.url);
    opts.window = opts.window || opts.iframe && safeGetWindow(opts.iframe);
    opts.url = opts.url || opts.iframe && safeGetSrc(opts.iframe);
    opts.target = opts.target || opts.url && parseOrigin(opts.url) || this.target || this.allowUnsafeTarget && "*";
    opts.namespace = opts.namespace || opts.url && parseNamespace(opts.url);
    if (!opts.target) {
      const err = new Error("IframeProtocol:createTarget: unable to determine secure target, will not use this target");
      err.data = opts;
      throw err;
    }
    opts.ip = this;
    return new IframeProtocolTarget(opts);
  }
  /**
     *
     *
     * @param {string} url
     * @return {Promise<HTMLIFrameElement>}
     * @memberof IframeProtocol
     */
  async appendIframe(url) {
    this.log("appendIframe: ", url);
    return new Promise((resolve, reject) => {
      const iframe = document.createElement("iframe");
      iframe.src = url;
      iframe.style.display = "none";
      this.root.appendChild(iframe);
      iframe.addEventListener("load", () => {
        resolve(iframe);
      });
      iframe.addEventListener("error", (e) => {
        reject(e);
      });
    });
  }
  /**
     * Establish communications with an already existing iframe or window
     *
     * @param {HTMLIFrameElement|HTMLElement|Window} iframe
     * @return {Promise<IframeProtocolTarget>}
     * @memberof IframeProtocol
     */
  async attach(iframe) {
    return await this.load({
      // @ts-ignore
      iframe
    });
  }
}
export {
  IframeProtocol as default
};
//# sourceMappingURL=iframe-protocol.js.map
